import { ChonkyActions, FileHelper } from "chonky";

const vietNameseI18n = {
  locale: "en",
  formatters: {
    formatFileModDate: (intl, file) => {
      const safeModDate = FileHelper.getModDate(file);
      if (safeModDate) {
        return `${intl.formatDate(safeModDate)}, ${intl.formatTime(
          safeModDate
        )}`;
      } else {
        return null;
      }
    },
    formatFileSize: (intl, file) => {
      if (!file || typeof file.size !== "number") return null;
      return `Kb: ${file.size}`;
    },
  },
  messages: {
    // Chonky UI translation strings. String IDs hardcoded into Chonky's source code.
    "chonky.toolbar.searchPlaceholder": "Tìm kiếm",
    "chonky.toolbar.visibleFileCount": `{fileCount, plural,
      =0 {}
      one {# Tệp tin}
      other {# Tệp tin}
  }`,
    "chonky.toolbar.selectedFileCount": `{fileCount, plural,
            =0 {}
            one {# đang chọn}
            other {# đang chọn}
        }`,
    "chonky.toolbar.hiddenFileCount": `{fileCount, plural,
            =0 {}
            one {# bị ẩn}
            other {# bị ẩn}
        }`,
    "chonky.fileList.nothingToShow": "Không có data!",
    "chonky.contextMenu.browserMenuShortcut": "Menu trình duyệt: {shortcut}",

    // File action translation strings. These depend on which actions you have
    // enabled in Chonky.
    [`chonky.actionGroups.Actions`]: "Hành động",
    [`chonky.actionGroups.Options`]: "Tùy chọn",
    [`chonky.actions.${ChonkyActions.OpenParentFolder.id}.button.name`]:
      "Mở thư mục mẹ",
    [`chonky.actions.${ChonkyActions.UploadFiles.id}.button.name`]:
      "Tải ảnh lên",
    [`chonky.actions.${ChonkyActions.CreateFolder.id}.button.name`]:
      "Thư mục mới",
    [`chonky.actions.${ChonkyActions.CreateFolder.id}.button.tooltip`]:
      "Tạo một thư mục mới",
    [`chonky.actions.${ChonkyActions.DeleteFiles.id}.button.name`]:
      "Xóa các tập tin",
    [`chonky.actions.${ChonkyActions.OpenSelection.id}.button.name`]:
      "Mở lựa chọn",
    [`chonky.actions.${ChonkyActions.SelectAllFiles.id}.button.name`]:
      "Chọn tất cả",
    [`chonky.actions.${ChonkyActions.ClearSelection.id}.button.name`]:
      "Đặt lại lựa chọ",
    [`chonky.actions.${ChonkyActions.EnableListView.id}.button.name`]:
      "Hiển thị theo danh sách",
    [`chonky.actions.${ChonkyActions.EnableGridView.id}.button.name`]:
      "Hiển thị các biểu tượng",
    [`chonky.actions.${ChonkyActions.SortFilesByName.id}.button.name`]:
      "Lọc theo tên",
    [`chonky.actions.${ChonkyActions.SortFilesBySize.id}.button.name`]:
      "Lọc theo kích thước",
    [`chonky.actions.${ChonkyActions.SortFilesByDate.id}.button.name`]:
      "Lọc theo ngày",
    [`chonky.actions.${ChonkyActions.ToggleHiddenFiles.id}.button.name`]:
      "Các tệp ẩn",
    [`chonky.actions.${ChonkyActions.ToggleShowFoldersFirst.id}.button.name`]:
      "Thư mục ở đầu",
  },
};

export default vietNameseI18n;
